<template>
    <div id="receive-address">
        <div id="receive-address-header">
            <span class="receive-address-title">选择收货地址</span>
        </div>

        <p v-if="addressList.length <= 0">没有收货地址</p>

        <div id="receive-address-item" v-for="(item, index) in addressList" :key="index" @click="addImg(index,item)">
            <label style="display: none">{{ item.id }}</label>
            <div class="receive-operation">
                <div class="receive-default">
                    <span class="chooseIcon" :class="payIndex===item.id?'active':''"></span>
                </div>
            </div>
            <div class="receive-profile-data">
                <span class="receive-data-username">
                    {{item.username}}
                </span>

                <span class="receive-phone-number">
                    {{item.userPhone}}
                </span>
            </div>

            <div class="receive-address">
                {{item.userAddress}}
            </div>
        </div>

        <div style="height: 100px; position: relative; background: #fdf9f7; "></div>

        <div id="receive-address_add_address" @click="addNewAddress">
            添加新地址
        </div>

        <div class="back-btn" @click="backBtn">返回</div>
    </div>
</template>

<script>
    import {GetAddressList} from "@/api/Address";
    import {starPhone} from "@/unitls";

    export default {
        name: "AddressChoose",

        data() {
            return {
                addressList: [],
                payIndex: 0, //默认选中第一个
            }
        },

        mounted() {
          this.requestAddressList();
          this.payIndex = localStorage.getItem('addressId');
        },

        methods: {
            requestAddressList() {
                GetAddressList(0, -1)
                    .then((response) => {
                        if (response.code === this.$API_CODE.OK) {
                            this.addressList = [];

                            response.data.list.forEach((item) => {
                                this.addressList.push({
                                    id: item.id,
                                    username: item.consignee,
                                    userAddress: item.area + item.address,
                                    userPhone:  starPhone(item.mobile),
                                    isDefault: item.default,
                                });
                                if (item.default) {
                                    this.payIndex = item.id;
                                }
                            });
                        }
                    })
            },

            addImg: function(index, item) {
                localStorage.setItem('addressId', item.id);
                localStorage.setItem('username', item.username);
                localStorage.setItem('userAddress', item.userAddress);
                localStorage.setItem('userPhone', item.userPhone);

                this.payIndex = item.id;

                this.$router.go(-1)
            },

            addNewAddress() {
                this.$router.push({path: '/addressAdd'})
            },

            backBtn() {
                this.$router.go(-1);
            }
        },

        activated() {
            let id = localStorage.getItem('addressId');
            if (id === null || id === '') {
                this.payIndex = localStorage.getItem('addressId');
            }
            this.requestAddressList();
        },

    }
</script>

<style scoped lang="scss">

    #receive-address {
        height: 100%;
        width: 100%;
        position: absolute;
        background: #fdf9f7;

        //header区域
        #receive-address-header {
            height: 6rem;
            line-height: 35px;
            background: url("../../assets/detail.png") no-repeat;
            background-size: 100% 6rem;
            width: 100%;

            .receive-address-title {
                color: white;
                float: right;
                margin-right: 20px;
                font-weight: bold;
                font-size: 1rem;
                line-height: 6rem;
            }
        }

        #receive-address-item {
            margin-top: 10px;
            border-bottom: 1px solid #dddddd;
            border-top: 1px solid #dddddd;
            background: #FFFFFF;
            padding: 20px 10px;
            position: relative;



            .receive-profile-data {
                float: left;
                font-size: 0.9rem;
                width: 85%;
                margin-left: 30px;

                .receive-data-username {
                    float: left;
                }

                .receive-phone-number {
                    float: right;
                }
            }

            .receive-address {
                clear: both;
                text-align: left;
                font-size: 0.9rem;
                margin-left: 30px;
            }

            .receive-operation {
                position: absolute;

                .receive-default {
                    float: left;
                    font-size: 0.9rem;
                }
            }

            .clear {
                clear: both;
                margin-bottom: 20px;
            }
        }

        .chooseIcon {
            width: 20px;
            height: 20px;
            display: inline-block;
            margin-top: 5px;
            background: url(../../assets/choose2.png)no-repeat;
            background-size: 100%;
        }

        .chooseIcon.active {
            width: 20px;
            height: 20px;
            margin-top: 5px;
            display: inline-block;
            background: url(../../assets/choose1.png)no-repeat;
            background-size: 100%;
        }


        #receive-address_add_address {
            height: 45px;
            background: #ea2d53;
            right: 0;
            bottom: 0;
            left: 0;
            width: 50%;
            position: fixed;
            z-index: 1;
            color: #FFFFFF;
            font-size: 1rem;
            line-height: 45px;
        }
        .back-btn {
            position: fixed;
            z-index: 1;
            right: 0;
            bottom: 0;
            background: #fdf9f7;
            margin: auto;
            width: 50%;
            font-size: 1rem;
            font-weight: bold;
            color: #ea2d53;
            border: 1px solid #ea2d53;
            padding: 12px;
        }
    }
</style>